export const onlyDigit = /^\$?\d+(,\d{3})*(\.\d*)?$/;

export const onlyNumber = /^[0-9]*$/;

export const onlyNumberAndLetters = /^[A-Za-z0-9]*$/;

export const email = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
